<template>
  <SimplePDFViewer :docURL="(messages.patientDoc ? messages.patientDoc : fname)" :key="messages.patientDoc" height="100%" />
</template>

<script>
import broadcast from "../mixins/windowSync.js";
import SimplePDFViewer from "../components/SimplePDFViewer.vue";

export default {
  name: "PopoutPDFViewer",
  mixins: [broadcast],
  components: {SimplePDFViewer},
  data() {
    return {
      fname: null,
      imgfile: null,
    };
  },
  watch: {
    //   messages:{
    //     handler: function (newData) {
    //       // console.log("NEW MESSAGE");
    //       // console.log(JSON.stringify(newData));
    //       this.fname = newData.patientDoc;
    //     },
    //     deep: true,
    //   },
  },
  methods: {
    b64er() {
      const reader = new FileReader();
      reader.readAsDataURL(require("../assets/" + this.fname));
      reader.onload = () => {
        //// console.log(reader.result);
        this.imgfile = reader.result;
      };
    },
    closingPopout(){
        this.endBroadcast("patientDoc");
    },
  },
  computed: {},
  created() {
    this.fname = this.$route.query.fname;
    // console.log("CREATED " + this.fname);
    window.addEventListener('beforeunload', this.closeWindow)
  },
  mounted() {
    this.startBroadcast("patientDoc");
    // console.log("MOUNTED " + this.fname);
  },
};
</script>

<style></style>
